<template>
    <div class="luckbank-container text-center">
        <h5>Luck Bank</h5>
        <div
            class="luckpoints d-flex flex-wrap justify-content-center align-items-center"
        >
            <div
                v-for="i in 3"
                :key="'luckpoint-' + i"
                class="d-flex align-items-center"
            >
                <div
                    class="luckpoint-circle"
                    :class="{ filled: i <= luckpoints }"
                    @click="setLuckpoints(i)"
                    :title="`Luckpoint ${i}`"
                ></div>
                <div v-if="i === 1" class="luckpoint-divider"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LuckbankTracker",
    props: {
        initial: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            luckpoints: this.initial, // value from 0 to 16
            lastClickedLuckpoint: null,
        };
    },
    methods: {
        setLuckpoints(count) {
            if (this.lastClickedLuckpoint === count) {
                // If the same hitpoint is clicked twice, turn it off
                this.luckpoints = count - 1;
                this.lastClickedLuckpoint = null;
            } else {
                this.luckpoints = count;
                this.lastClickedLuckpoint = count;
            }
            this.$emit("updateLuckbank", this.luckpoints);
        },
    },
};
</script>

<style scoped>
.luckbank-container {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}
.luckpoints {
    max-width: 100%;
}

.luckpoint-circle {
    width: 24px;
    height: 24px;
    border: 2px solid #555;
    border-radius: 50%;
    display: inline-block;
    margin: 5px;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.luckpoint-circle.filled {
    background: #73bd69;
    border-color: #73bd69;
}
.luckpoint-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.luckpoint-divider {
    width: 2px;
    height: 30px; /* adjust to your liking */
    background-color: #555;
    margin: 5px 0;
}
</style>

